import { render, staticRenderFns } from "./pain.vue?vue&type=template&id=503e33f8&scoped=true&"
import script from "./pain.vue?vue&type=script&lang=js&"
export * from "./pain.vue?vue&type=script&lang=js&"
import style0 from "./pain.vue?vue&type=style&index=0&id=503e33f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503e33f8",
  null
  
)

export default component.exports